// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"129":"fa754c185057bcfb","888":"ce8a8a53dc34eda0"}[chunkId] + ".css";
};